'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconListTreeDatabase, iconListTreeDatabaseTag } from '@ni/nimble-components/dist/esm/icons/list-tree-database';
import { wrap } from '../../utilities/react-wrapper';

export type { IconListTreeDatabase };
export { iconListTreeDatabaseTag };
export const NimbleIconListTreeDatabase = wrap(IconListTreeDatabase);